import React from "react";

function NFTDevHero() {
  return (
    <>
      {/* <div
        className="banner-style-seven-area text-light bg-cover"
        style={{
          background:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-21.jpg)",
        }}
      >
        <div className="banner-seven-illustration">
          <img
            className="wow fadeInLeft"
            data-wow-delay="700ms"
            src="https://validthemes.net/site-template/robok/assets/img/illustration/15.png"
            alt="Image Not Found"
          />
          <img
            className="fade-up-anim"
            src="https://validthemes.net/site-template/robok/assets/img/illustration/14.png"
            alt="Image Not Found"
          />
        </div>
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-seven-content">
                <h2 className="split-text-right split-text-in-right">
                  NFT Development & Launching Services
                </h2>
                <div className="info">
                  <p className="wow fadeInUp" data-wow-delay="400ms">
                    Join the revolution & partner with us to launch your own
                    NFTs in the market! We design, develop & mint NFTs on
                    different blockchain ecosystems!
                  </p>
                  <div
                    className="button mt-30 wow fadeInUp"
                    data-wow-delay="600ms"
                  >
                    <a href="#" className="btn btn-style-one light">
                      Join Today
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  NFT Development & Launching Services
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Join the revolution & partner with us to launch your own
                    NFTs in the market! We design, develop & mint NFTs on
                    different blockchain ecosystems!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NFTDevHero;
